// extracted by mini-css-extract-plugin
export default {"circle":"progress_circle__aqZjo","percent":"progress_percent__LD3p8"};